/**
 * Whether a generation run is for someone other than the advertiser whose
 * pictures the ad is currently carrying.
 *
 * Kept apart from the hook so it can be read and tested on its own: it is the
 * decision that clears the editor, and getting it wrong is expensive in both
 * directions — too eager and it throws away work on a re-run, too shy and the
 * new advertiser inherits the previous one's photographs.
 */

function trimmed(value) {
  return typeof value === 'string' ? value.trim() : ''
}

export function advertiserChanged(previous, incoming, configuration) {
  // The name is what both sides always carry, so it decides. The place id only
  // settles the case of two advertisers sharing one.
  // Ad v4 keeps the advertiser in Campaign Setting and the brand under `data`; v3 at the top.
  const wasName = trimmed(previous?.name)
    || trimmed(configuration?.campaign?.advertiser?.name)
    || trimmed(configuration?.data?.brand?.name)
    || trimmed(configuration?.brand?.name)
  const isName = trimmed(incoming?.advertiser_name)

  // An ad that names no advertiser has nothing that belonged to anyone, and a
  // run that names none says nothing about whether this is someone else.
  if (!wasName || !isName) return false

  const wasPlace = trimmed(previous?.placeId)
  const isPlace = trimmed(incoming?.google_place_id)
  if (wasPlace && isPlace && wasPlace !== isPlace) return true

  return wasName.toLowerCase() !== isName.toLowerCase()
}
